import { EMPTY_OBJECT } from '../../../constants/common'
import { toUserMultiValue } from '../../User'

export function checkIsWaitingOnUserMasked(user) {
  return Boolean(user?.is_identity_masked)
}

export function toWaitingOnUserValue(user) {
  return toUserMultiValue({
    ...user,
    avatar: user.avatar_url,
    fullname: user.name,
  })
}

export function getWaitingOnExportValue({ attention, t }) {
  const { waiting_on: waitingOn } = attention ?? EMPTY_OBJECT

  return waitingOn?.label ? t(waitingOn.label) : null
}
